<template>
  <div class="question-block">
    <div class="question-block__title">
      <drag-title-block class="question-block__drag sortable-handle handleClass" :title="String(index + 1)" />

      <div class="question-block__delete" :class="{ disabled: lastQuestion }" @click="deleteQuestion">
        <i class="icon icon-recycle_bin"></i>
      </div>
    </div>

    <div class="question-block__question-body">
      <div class="block-title">
        <textarea :id="'editor' + (index + 1)" v-model="body"></textarea>

        <div class="row-block block-mandatory">
          <div>
            <vchecklabel v-model="isRequired" :label="$tr('vacancy.videoInterview.mandatory')" />
          </div>
          <div>
            <vchecklabel v-model="isEnglish" :label="$tr('vacancy.videoInterview.isEnglish')" />
          </div>
        </div>
      </div>

      <div class="time-interval">
        <div class="row-block">
          <div class="from">
            <div class="prefix">{{ $tr('vacancy.videoInterview.timeForAnswer') }}</div>

            <masked-input
              v-model="answerTime"
              type="text"
              placeholder="02:30"
              class="form-control vcv-input"
              :mask="[/[0-6]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]"
              keep-char-positions
            />
          </div>

          <div class="to">
            <div class="prefix">{{ $tr('vacancy.videoInterview.timeForPreparation') }}</div>

            <masked-input
              v-model="preparationTime"
              type="text"
              placeholder="01:30"
              class="form-control vcv-input"
              :mask="[/[0-6]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]"
              keep-char-positions
              :disabled="retryable"
            />
          </div>
        </div>

        <div class="row-block">
          <vchecklabel v-model="retryable" :label="$tr('vacancy.videoInterview.retryable')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DragTitleBlock from '@/routes_new/inner/vacancy/components/DragTitleBlock';
import ProductQuestionRow from '@/routes_new/inner/vacancy/video/base/questions/Row.vue';

export default {
  components: {
    DragTitleBlock
  },

  extends: ProductQuestionRow,

  computed: {
    isEnglish: {
      get() {
        return this.model.is_en;
      },

      set(val) {
        this.updateModel({ is_en: val });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.question-block {
  background-color: #fff;

  textarea {
    width: 100%;
    min-height: 150px;
  }

  .block-title {
    margin-bottom: 20px;

    .block-mandatory {
      display: flex;
      justify-content: flex-start;

      > * {
        margin-right: 15px;
      }
    }
  }

  .vcheckbox_label {
    margin-top: 10px;
  }

  .from {
    margin-right: 10px;
  }

  .prefix {
    @include mixin-text-tag;
  }
}
</style>
